import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import FormPage from './pages/FormPage';
import FeedbackPage from './pages/FeedbackPage';
import OverviewPage from './pages/OverviewPage';
import ScanQr from './pages/qrCodeScannerPage';
import EndPage from './pages/EndPage';
import ViewFeedbackPage from './pages/viewfeedbackPage';
import ProtectedRoute from './ProtectedRoute';
import SubmitPage from './pages/SubmitPage'; // Import the SubmitPage
import StaticFeedbackPage from './pages/exampleFeedbackView';
const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const storedAuth = localStorage.getItem('isAuthenticated');
    return storedAuth === 'true';
  });

  useEffect(() => {
    localStorage.setItem('isAuthenticated', isAuthenticated);
  }, [isAuthenticated]);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };



  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            !isAuthenticated ? (
              <Login setIsAuthenticated={handleLogin} />
            ) : (
              <Navigate to="/overview" />
            )
          }
        />
        <Route path="/submit/:code" element={<SubmitPage />} />
        <Route
          path="/init"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <ScanQr isAuthenticated={isAuthenticated} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/demo"
          element={<Login setIsAuthenticated={handleLogin} />}
        />
        <Route
          path="/form"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <FormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ScanQR"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <ScanQr />
            </ProtectedRoute>
          }
        />
        <Route
          path="/feedback"
          element={
            <ProtectedRoute isAuthenticated={!isAuthenticated}>
              <FeedbackPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/overview"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <OverviewPage setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/viewfeedback"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <ViewFeedbackPage setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/exampleFeedbackView"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <StaticFeedbackPage setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/end"
          element={
            <ProtectedRoute isAuthenticated={!isAuthenticated}>
              <EndPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? "/overview" : "/login"} />}
        />
      </Routes>
    </Router>
  );
};

export default App;
